import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import {useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../hooks/hooks';
import { format } from '../../../../common/services/date.service';
import { layouts } from '../../../../redux/layouts/action';
import { cards } from '../../../../redux/cards/action';
import { selectCardListItems } from '../../../../redux/cards/selector';
import WebsitesLayoutComponent from '../components/website-layout/website-layout.component';
import PageLoader from '../../../../components/PageLoader';
import storePersist from '../../../../redux/storePersist';


const WebsiteLayout= () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const {websiteId, pageId,id} = useParams()
  const routeQuery = useSelector(selectCardListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  var tenantId = storePersist?.get("tokenData")?.current?.result?.TokenMetadata?.TenantId;
  const [pageData, setPageData] = useState(1)
  const [
    cardDetails,
    setCardDetails
  ] = useState<any>([])
  const [
    selectedLayouts,
    setSelectedLayouts
  ] = useState<any>({PlatformWebsiteId: websiteId,
    PlatformWebsitePageId: pageId,
    TenantId: tenantId
  })
 
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer (params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      
      { field: 'message.CardName', headerName: 'CardName', sortable: true, filter: true,isEdit: true }, 
      { field: 'message.CardVersionId', headerName: 'Card Version' },
    
  
    ]);
  }

  const fetchWebsiteLayoutById= ()=>{
    dispatch(cards.list({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/platform-website-layout-cards/list`,entity:'cards',jsonData:{     
        "Filters": [
            {
              "FieldName": "PlatformWebSiteLayoutId",
              "FilterOperatorId": 1,
              "FieldValue": id,
              "FieldType": "number"
            }
            
          ],
          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",
  
}})).then(()=>{
  setIsQuery(true)
})

  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedLayouts({ ...selectedLayouts, [field]: event });
  }

  useEffect(
    () => {
    
      if (Number(id) > 0) {
        fetchWebsiteLayoutById()
        createColumnDefs()
        setIsLoading(false)
      }
      else{
        setIsLoading(false)
      }

},
    [pageData]
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setCardDetails(routeQuery?.result?.items)
      }
    },
    [isQuery]
  )
 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    await dispatch(layouts.resetAction({ actionType: 'create' }))
      await dispatch(layouts.create({url:`https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/platform-website-layouts`,entity:'layouts',jsonData:{
          
      Records: [
        {
        
          "context": {},
          "message": {
            ...selectedLayouts
          }
      }
      ]
    
  }}))
  .then(()=>{
    back()
  })
  }
const back=()=>{
  navigate(`/web-platform/websites/platform-website/${websiteId}/platform-website-page/${pageId}`)
} 

const handleDelete=(data: any)=>{
  dispatch(cards.delete({
    url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/platform-website-layout-cards/delete`,
    entity: 'cards',
    jsonData: {
      Records: [
        {
        "context": {},
        "message": {
              Id: data?.message?.Id
          }
        }
      ]
    }
})).then(() => {
  setCardDetails((prevCardDetails: any) => 
    prevCardDetails.filter((item: any) => item.message.Id !== data.message.Id)
  );
  });
}
const handleAdd=()=>{
    navigate(`platform-website-layout-card/${0}`)
  }
const handleEdit=(data: any)=>{
    navigate(`platform-website-layout-card/${data?.message?.Id}`)
   }
   const additionButtons: any = [
    {
      name: 'Add Cards',
      callback: () => handleAdd(),
    },
    {
      name: 'Back',
      callback: () => back(),
    }
  ];
    return (
    <>
      {isLoading ? <PageLoader /> : 
          <WebsitesLayoutComponent 
           handleInnerFormChange={handleInnerFormChange}
           selectedLayouts={selectedLayouts}
           back={back}
           handleFormSubmit={handleFormSubmit}
           id={id}
           columnDefs={columnDefs}
           onEdit={handleEdit}
           cardDetails ={cardDetails}
           additionButtons={additionButtons}
           paginationData={routeQuery?.result?.pagination}
           setPageData={setPageData}
           handleDelete={handleDelete}
          /> 
    } 
          </>
    )
    
    }
   
    export default WebsiteLayout;